import React, { useEffect, useState } from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import ApiService from "../../Services/ApiService";
import { handleApiErrors } from "../../Utils/Utils";
import parse from "html-react-parser";

const TermsAndConditions = () => {
  const [policy, setPolicy] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await ApiService.getTermsAndConditions();
      setPolicy(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  }

  return (
    <div className="d-flex flex-column mb-auto">
      <PageTitleBanner PageTitle={"Terms and Conditions"} breadCrumpPageTitle={"Terms and Conditions"} />
      <div className="text-content-page-container d-flex flex-column align-items-center">
        <h2 className="Heading fw-600 mb-2 headingColor text-center">
          {policy?.title ?? "Terms and Conditions"}
        </h2>

        <div>
          {policy?.details && parse(policy.details)}
        </div>
      </div>
    </div>
  );
};
export default TermsAndConditions;
